import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { trackLLMSourceAcquisition } from '@nykaa/seo';
import { pushEvent } from 'helpers/utils/dataLayer';

/**
 * Custom hook to track LLM platform acquisition
 * Fetches llmReferrerConfig from remote config and tracks the source
 */
const LLM_SOURCE_EVENT = 'llmPlatformAcquisition';
const useLLMSourceTracking = (): void => {
  const llmReferrerConfig = useSelector(
    (state: State) => state.remoteConfig.configs?.llmReferrerConfig
  );

  useEffect(() => {
    // Check if feature is enabled before tracking
    if (!llmReferrerConfig?.enabled) return;

    trackLLMSourceAcquisition(
      llmReferrerConfig.patterns,
      pushEvent,
      LLM_SOURCE_EVENT
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useLLMSourceTracking;
